// 鐧诲綍鎺ュ彛
import { axios } from "../axios";

const userApi = {
    login: "/api/sign-in",
    systemInitStatus: "/api/system/init_status",
    systemInitAdmin: "/api/system/init_admin",
    reservationCode: "/api/reservation/code",
    reservationSubmit: "/api/reservation/submit",
    newsList: "/api/news/list",
    newsDetail: "/api/news/detail",
    logout: "/api/logout",
    menus: "/api/menus",

    roleAll: "/api/role/all",
    permissionAll: "/api/permission/all",
    menuAll: "/api/menu/all",
    apiAll: "/api/api/all",

    logLoginPages: "/api/log_login/pages",
    logOperationPages: "/api/log_operation/pages",
    apiLatencyStats: "/api/metrics/api_latency",
    systemMetrics: "/api/metrics/system",

    adminPages: "/api/admin/pages",
    adminInfo: "/api/admin/info",
    adminInfoUpdate: "/api/admin/update",
    adminDelete: "/api/admin/delete",
    adminAdd: "/api/admin/add",
    adminChangePassword: "/api/admin/change_password",

    noticePages: "/api/notice/pages",
    noticeInfo: "/api/notice/info",
    noticeInfoUpdate: "/api/notice/update",
    noticeDelete: "/api/notice/delete",
    noticeAdd: "/api/notice/add",
    noticePublish: "/api/notice/publish",

    seasonPages: "/api/season/pages",
    seasonInfo: "/api/season/info",
    seasonInfoUpdate: "/api/season/update",
    seasonDelete: "/api/season/delete",
    seasonAdd: "/api/season/add",

    serverVersionInfo: "/api/server_version/info",

    serverMgrPages: "/api/servermgr/pages",
    serverMgrInfo: "/api/servermgr/info",
    serverMgrInfoUpdate: "/api/servermgr/update",
    serverMgrDelete: "/api/servermgr/delete",
    serverMgrAdd: "/api/servermgr/add",
    serverMgrSetDefault: "/api/servermgr/set_default",
    robotPages: "/api/robot/pages",
    robotStartStress: "/api/robot/start_stress",
    robotStopStress: "/api/robot/stop_stress",
    robotStrategySave: "/api/robot_strategy/save",
    robotStrategyList: "/api/robot_strategy/list",
    robotStrategyInfo: "/api/robot_strategy/info",
    robotStrategyDelete: "/api/robot_strategy/delete",
    robotStrategyRunStart: "/api/robot_strategy/run_start",
    robotStrategyRunList: "/api/robot_strategy/run_list",
    robotStrategyRunStop: "/api/robot_strategy/run_stop",
    robotStrategyRunDelete: "/api/robot_strategy/run_delete",

    rolePages: "/api/role/pages",
    roleInfo: "/api/role/info",
    roleInfoUpdate: "/api/role/update",
    roleDelete: "/api/role/delete",
    roleAdd: "/api/role/add",

    permissionPages: "/api/permission/pages",
    permissionInfo: "/api/permission/info",
    permissionInfoUpdate: "/api/permission/update",
    permissionDelete: "/api/permission/delete",
    permissionAdd: "/api/permission/add",

    menuPages: "/api/menu/pages",
    menuInfo: "/api/menu/info",
    menuInfoUpdate: "/api/menu/update",
    menuDelete: "/api/menu/delete",
    menuAdd: "/api/menu/add",

    apiPages: "/api/api/pages",
    apiInfo: "/api/api/info",
    apiInfoUpdate: "/api/api/update",
    apiDelete: "/api/api/delete",
    apiAdd: "/api/api/add",

    ////////////////////////////////////////////////////////////////////////////////////

    getUserInfo: "/api/operator/get_acc",
    setUserInfo: "/api/operator/set_acc",
    accountMigrate: "/api/operator/account_migrate",
    accountItemOptions: "/api/operator/account_item_options",
    accountSetItemCount: "/api/operator/account_set_item_count",
    delUser : "/api/operator/del_acc",
    BlacklistAdd : "/api/operator/blacklist_add",
    BlacklistRmv : "/api/operator/blacklist_rmv",
    BlackListList : "/api/operator/blacklist_list", 

    mailSend : "/api/operator/mail_send", //鍙戦€侀偖浠?
    mailList : "/api/operator/mail_list", //鑾峰彇閭欢鍒楄〃
    mailTemplateSave : "/api/operator/mail_template_save",
    mailTemplateList : "/api/operator/mail_template_list",
    mailTemplateDelete : "/api/operator/mail_template_delete",
    itemList : "/api/operator/item_list", //鑾峰彇褰撳墠鐨勯亾鍏峰垪琛?
    storeOrderList : "/api/operator/store_order_list",
    storeOrderRepair : "/api/operator/store_order_repair",
    gachaRecordList : "/api/operator/gacha_record_list",
    gachaRecordStats : "/api/operator/gacha_record_stats",
    gachaSimulate : "/api/operator/gacha_simulate",
    itemFlowList : "/api/operator/item_flow_list",
    maintainAdd : "/api/operator/maintain_add",
    maintainWriteAdd : "/api/operator/maintain_write_add",
    maintainDelay : "/api/operator/maintain_delay",
    maintainChangeDesc : "/api/operator/maintain_change_desc",
    maintainWriteRmv : "/api/operator/maintain_write_rmv",
    maintainUndo : "/api/operator/maintain_undo",
    maintainClose : "/api/operator/maintain_close",
    maintainList : "/api/operator/maintain_list",
    maintainOut : "/api/operator/maintain_out",
    accountLock : "/api/operator/account_lock",
    accountUnlock : "/api/operator/account_unlock",
    accountLockInfo : "/api/operator/account_lock_info",
    redeemAdd : "/api/operator/redeem_add",
    redeemClose : "/api/operator/redeem_close",
    redeemList : "/api/operator/redeem_list",
    redeemBatchAdd : "/api/operator/redeem_batch_add",
    redeemBatchList : "/api/operator/redeem_batch_list",
    redeemBatchPublish : "/api/operator/redeem_batch_publish",
    redeemCodePage : "/api/operator/redeem_code_page",
    redeemCodeExport : "/api/operator/redeem_code_export",
    redeemPlayerCodeList : "/api/operator/redeem_player_code_list",
    notifyAdd : "/api/operator/notify_add",
    notifyImportTemplate : "/api/operator/notify_import_template",
    notifyImport : "/api/operator/notify_import",
    notifyList : "/api/operator/notify_list",
    notifyChange : "/api/operator/notify_change",
    notifyRmv : "/api/operator/notify_rmv",
    notifyPublishStatus : "/api/operator/notify_publish_status",
    notifyPublish : "/api/operator/notify_publish",
    notifyUnpublish : "/api/operator/notify_unpublish",
};

export function login(parameter) {
    return axios({
        url: userApi.login,
        method: "post",
        data: parameter
    });
}

export function systemInitStatus(parameter) {
    return axios({
        url: userApi.systemInitStatus,
        method: "get",
        params: parameter
    });
}

export function systemInitAdmin(parameter) {
    return axios({
        url: userApi.systemInitAdmin,
        method: "post",
        data: parameter
    });
}

export function reservationCode(parameter) {
    return axios({
        url: userApi.reservationCode,
        method: "post",
        data: parameter
    });
}

export function reservationSubmit(parameter) {
    return axios({
        url: userApi.reservationSubmit,
        method: "post",
        data: parameter
    });
}

export function newsList(parameter) {
    return axios({
        url: userApi.newsList,
        method: "get",
        params: parameter
    });
}

export function newsDetail(parameter) {
    return axios({
        url: userApi.newsDetail,
        method: "get",
        params: parameter
    });
}

export function logout(parameter) {
    return axios({
        url: userApi.logout,
        method: "get",
        params: parameter
    });
}

export function menus(parameter) {
    return axios({
        url: userApi.menus,
        method: "get",
        params: parameter
    });
}

export function roleAll(parameter) {
    return axios({
        url: userApi.roleAll,
        method: "get",
        params: parameter
    });
}

export function permissionAll(parameter) {
    return axios({
        url: userApi.permissionAll,
        method: "get",
        params: parameter
    });
}

export function menuAll(parameter) {
    return axios({
        url: userApi.menuAll,
        method: "get",
        params: parameter
    });
}

export function apiAll(parameter) {
    return axios({
        url: userApi.apiAll,
        method: "get",
        params: parameter
    });
}


// admin
export function adminPages(parameter) {
    return axios({
        url: userApi.adminPages,
        method: "get",
        params: parameter
    });
}

export function adminInfo(parameter) {
    return axios({
        url: userApi.adminInfo,
        method: "get",
        params: parameter
    });
}

export function adminInfoUpdate(parameter) {
    return axios({
        url: userApi.adminInfoUpdate,
        method: "post",
        data: parameter
    });
}

export function adminDelete(parameter) {
    return axios({
        url: userApi.adminDelete,
        method: "post",
        data: parameter
    });
}

export function adminAdd(parameter) {
    return axios({
        url: userApi.adminAdd,
        method: "post",
        data: parameter
    });
}

export function adminChangePassword(parameter) {
    return axios({
        url: userApi.adminChangePassword,
        method: "post",
        data: parameter
    });
}

// notice
export function noticePages(parameter) {
    return axios({
        url: userApi.noticePages,
        method: "get",
        params: parameter
    });
}

export function noticeInfo(parameter) {
    return axios({
        url: userApi.noticeInfo,
        method: "get",
        params: parameter
    });
}

export function noticeInfoUpdate(parameter) {
    return axios({
        url: userApi.noticeInfoUpdate,
        method: "post",
        data: parameter
    });
}

export function noticeDelete(parameter) {
    return axios({
        url: userApi.noticeDelete,
        method: "post",
        data: parameter
    });
}

export function noticeAdd(parameter) {
    return axios({
        url: userApi.noticeAdd,
        method: "post",
        data: parameter
    });
}

export function noticePublish(parameter) {
    return axios({
        url: userApi.noticePublish,
        method: "post",
        data: parameter
    });
}

// season
export function seasonPages(parameter) {
    return axios({
        url: userApi.seasonPages,
        method: "get",
        params: parameter
    });
}

export function seasonInfo(parameter) {
    return axios({
        url: userApi.seasonInfo,
        method: "get",
        params: parameter
    });
}

export function seasonInfoUpdate(parameter) {
    return axios({
        url: userApi.seasonInfoUpdate,
        method: "post",
        data: parameter
    });
}

export function seasonDelete(parameter) {
    return axios({
        url: userApi.seasonDelete,
        method: "post",
        data: parameter
    });
}

export function seasonAdd(parameter) {
    return axios({
        url: userApi.seasonAdd,
        method: "post",
        data: parameter
    });
}

export function serverVersionInfo(parameter) {
    return axios({
        url: userApi.serverVersionInfo,
        method: "get",
        params: parameter
    });
}

// server mgr
export function serverMgrPages(parameter) {
    return axios({
        url: userApi.serverMgrPages,
        method: "get",
        params: parameter
    });
}

export function serverMgrInfo(parameter) {
    return axios({
        url: userApi.serverMgrInfo,
        method: "get",
        params: parameter
    });
}

export function serverMgrInfoUpdate(parameter) {
    return axios({
        url: userApi.serverMgrInfoUpdate,
        method: "post",
        data: parameter
    });
}

export function serverMgrDelete(parameter) {
    return axios({
        url: userApi.serverMgrDelete,
        method: "post",
        data: parameter
    });
}

export function serverMgrAdd(parameter) {
    return axios({
        url: userApi.serverMgrAdd,
        method: "post",
        data: parameter
    });
}

export function serverMgrSetDefault(parameter) {
    return axios({
        url: userApi.serverMgrSetDefault,
        method: "post",
        data: parameter
    });
}

export function robotPages(parameter) {
    return axios({
        url: userApi.robotPages,
        method: "get",
        params: parameter
    });
}

export function robotStartStress(parameter) {
    return axios({
        url: userApi.robotStartStress,
        method: "post",
        headers: {
            "Content-Type": "application/json"
        },
        transformRequest: [
            (data) => JSON.stringify(data)
        ],
        data: parameter
    });
}

export function robotStopStress(parameter) {
    return axios({
        url: userApi.robotStopStress,
        method: "post",
        headers: {
            "Content-Type": "application/json"
        },
        transformRequest: [
            (data) => JSON.stringify(data)
        ],
        data: parameter
    });
}

export function robotStrategySave(parameter) {
    return axios({
        url: userApi.robotStrategySave,
        method: "post",
        headers: {
            "Content-Type": "application/json"
        },
        transformRequest: [
            (data) => JSON.stringify(data)
        ],
        data: parameter
    });
}

export function robotStrategyList(parameter) {
    return axios({
        url: userApi.robotStrategyList,
        method: "post",
        headers: {
            "Content-Type": "application/json"
        },
        transformRequest: [
            (data) => JSON.stringify(data)
        ],
        data: parameter
    });
}

export function robotStrategyInfo(parameter) {
    return axios({
        url: userApi.robotStrategyInfo,
        method: "post",
        headers: {
            "Content-Type": "application/json"
        },
        transformRequest: [
            (data) => JSON.stringify(data)
        ],
        data: parameter
    });
}

export function robotStrategyDelete(parameter) {
    return axios({
        url: userApi.robotStrategyDelete,
        method: "post",
        headers: {
            "Content-Type": "application/json"
        },
        transformRequest: [
            (data) => JSON.stringify(data)
        ],
        data: parameter
    });
}

export function robotStrategyRunStart(parameter) {
    return axios({
        url: userApi.robotStrategyRunStart,
        method: "post",
        headers: {
            "Content-Type": "application/json"
        },
        transformRequest: [
            (data) => JSON.stringify(data)
        ],
        data: parameter
    });
}

export function robotStrategyRunList(parameter) {
    return axios({
        url: userApi.robotStrategyRunList,
        method: "post",
        headers: {
            "Content-Type": "application/json"
        },
        transformRequest: [
            (data) => JSON.stringify(data)
        ],
        data: parameter
    });
}

export function robotStrategyRunStop(parameter) {
    return axios({
        url: userApi.robotStrategyRunStop,
        method: "post",
        headers: {
            "Content-Type": "application/json"
        },
        transformRequest: [
            (data) => JSON.stringify(data)
        ],
        data: parameter
    });
}

export function robotStrategyRunDelete(parameter) {
    return axios({
        url: userApi.robotStrategyRunDelete,
        method: "post",
        headers: {
            "Content-Type": "application/json"
        },
        transformRequest: [
            (data) => JSON.stringify(data)
        ],
        data: parameter
    });
}

// role
export function rolePages(parameter) {
    return axios({
        url: userApi.rolePages,
        method: "get",
        params: parameter
    });
}

export function roleInfo(parameter) {
    return axios({
        url: userApi.roleInfo,
        method: "get",
        params: parameter
    });
}

export function roleInfoUpdate(parameter) {
    return axios({
        url: userApi.roleInfoUpdate,
        method: "post",
        data: parameter
    });
}

export function roleDelete(parameter) {
    return axios({
        url: userApi.roleDelete,
        method: "post",
        data: parameter
    });
}

export function roleAdd(parameter) {
    return axios({
        url: userApi.roleAdd,
        method: "post",
        data: parameter
    });
}


// permission
export function permissionPages(parameter) {
    return axios({
        url: userApi.permissionPages,
        method: "get",
        params: parameter
    });
}

export function permissionInfo(parameter) {
    return axios({
        url: userApi.permissionInfo,
        method: "get",
        params: parameter
    });
}

export function permissionInfoUpdate(parameter) {
    return axios({
        url: userApi.permissionInfoUpdate,
        method: "post",
        data: parameter
    });
}

export function permissionDelete(parameter) {
    return axios({
        url: userApi.permissionDelete,
        method: "post",
        data: parameter
    });
}

export function permissionAdd(parameter) {
    return axios({
        url: userApi.permissionAdd,
        method: "post",
        data: parameter
    });
}

// menu
export function menuPages(parameter) {
    return axios({
        url: userApi.menuPages,
        method: "get",
        params: parameter
    });
}

export function menuInfo(parameter) {
    return axios({
        url: userApi.menuInfo,
        method: "get",
        params: parameter
    });
}

export function menuInfoUpdate(parameter) {
    return axios({
        url: userApi.menuInfoUpdate,
        method: "post",
        data: parameter
    });
}

export function menuDelete(parameter) {
    return axios({
        url: userApi.menuDelete,
        method: "post",
        data: parameter
    });
}

export function menuAdd(parameter) {
    return axios({
        url: userApi.menuAdd,
        method: "post",
        data: parameter
    });
}

// api
export function apiPages(parameter) {
    return axios({
        url: userApi.apiPages,
        method: "get",
        params: parameter
    });
}

export function apiInfo(parameter) {
    return axios({
        url: userApi.apiInfo,
        method: "get",
        params: parameter
    });
}

export function apiInfoUpdate(parameter) {
    return axios({
        url: userApi.apiInfoUpdate,
        method: "post",
        data: parameter
    });
}

export function apiDelete(parameter) {
    return axios({
        url: userApi.apiDelete,
        method: "post",
        data: parameter
    });
}

export function apiAdd(parameter) {
    return axios({
        url: userApi.apiAdd,
        method: "post",
        data: parameter
    });
}


// logs
export function logLoginPages(parameter) {
    return axios({
        url: userApi.logLoginPages,
        method: "get",
        params: parameter
    });
}

export function logOperationPages(parameter) {
    return axios({
        url: userApi.logOperationPages,
        method: "get",
        params: parameter
    });
}

export function apiLatencyStats(parameter) {
    return axios({
        url: userApi.apiLatencyStats,
        method: "get",
        params: parameter
    });
}

export function systemMetrics(parameter) {
    return axios({
        url: userApi.systemMetrics,
        method: "get",
        params: parameter
    });
}


//////////////////////////////////////////////////////////////////////////////

export function getEcpmInfo(parameter) {
    return axios({
        url: userApi.getEcpmInfo,
        method: "post",
        params: parameter
    })
}

export function setEcpmInfo(parameter) {
    return axios({
        url: userApi.setEcpmInfo,
        method: "post",
        params: parameter,
    })
}

export function getUserInfo(parameter) {
    return axios({
        url: userApi.getUserInfo,
        method: "post",
        headers: {
            "Content-Type": "application/json"
        },
        transformRequest: [
            (data) => JSON.stringify(data)
        ],
        data: parameter,
    })
}

export function setUserInfo(parameter) {
    return axios({
        url: userApi.setUserInfo,
        method: "post",
        headers: {
            "Content-Type": "application/json"
        },
        transformRequest: [
            (data) => JSON.stringify(data)
        ],
        data: parameter,
    })
}

export function accountMigrate(parameter) {
    return axios({
        url: userApi.accountMigrate,
        method: "post",
        headers: {
            "Content-Type": "application/json"
        },
        transformRequest: [
            (data) => JSON.stringify(data)
        ],
        data: parameter,
    })
}

export function accountItemOptions(parameter) {
    return axios({
        url: userApi.accountItemOptions,
        method: "get",
        params: parameter,
    })
}

export function accountSetItemCount(parameter) {
    return axios({
        url: userApi.accountSetItemCount,
        method: "post",
        headers: {
            "Content-Type": "application/json"
        },
        transformRequest: [
            (data) => JSON.stringify(data)
        ],
        data: parameter,
    })
}

export function delUser(parameter) {
    return axios({
        url: userApi.delUser,
        method: "post",
        headers: {
            "Content-Type": "application/json"
        },
        transformRequest: [
            (data) => JSON.stringify(data)
        ],
        data: parameter,
    })
}

export function BlacklistAdd(parameter) {
    return axios({
        url: userApi.BlacklistAdd,
        method: "post",
        params: parameter,
    })
}

export function BlacklistRmv(parameter) {
    return axios({
        url: userApi.BlacklistRmv,
        method: "post",
        params: parameter,
    })
}

export function BlacklistList(parameter) {
    return axios({
        url: userApi.BlackListList,
        method: "post",
        params: parameter,
    })
}

export function WhitelistAdd(parameter) {
    return axios({
        url: userApi.WhitelistAdd,
        method: "post",
        params: parameter,
    })
}

export function WhitelistRmv(parameter) {
    return axios({
        url: userApi.WhitelistRmv,
        method: "post",
        params: parameter,
    })
}

export function WhitelistList(parameter) {
    return axios({
        url: userApi.WhitelistList,
        method: "post",
        params: parameter,
    })
}

export function GetVerPushList(parameter) {
    return axios({
        url: userApi.GetVerPushList,
        method: "post",
        params: parameter,
    })
}

export function AddVerPushList(parameter) {
    return axios({
        url: userApi.AddVerPushList,
        method: "post",
        params: parameter,
    })
}

export function mailSend(parameter, customHeaders = {}) {
    return axios({
        url: userApi.mailSend,
        method: "post",
        headers: {
            "Content-Type": "application/json",
            ...customHeaders,
        },
        transformRequest: [
            (data) => JSON.stringify(data)
        ],
        data: parameter,
    })
}

export function mailList(parameter) {
        return axios({
        url: userApi.mailList,
        method: "post",
        headers: {
            "Content-Type": "application/json"
        },
        transformRequest: [
            (data) => JSON.stringify(data)
        ],
        data: parameter,
    })
}

export function mailTemplateSave(parameter) {
    return axios({
        url: userApi.mailTemplateSave,
        method: "post",
        headers: {
            "Content-Type": "application/json"
        },
        transformRequest: [
            (data) => JSON.stringify(data)
        ],
        data: parameter,
    })
}

export function mailTemplateList(parameter) {
    return axios({
        url: userApi.mailTemplateList,
        method: "post",
        headers: {
            "Content-Type": "application/json"
        },
        transformRequest: [
            (data) => JSON.stringify(data)
        ],
        data: parameter,
    })
}

export function mailTemplateDelete(parameter) {
    return axios({
        url: userApi.mailTemplateDelete,
        method: "post",
        headers: {
            "Content-Type": "application/json"
        },
        transformRequest: [
            (data) => JSON.stringify(data)
        ],
        data: parameter,
    })
}

export function itemList(parameter) {
    return axios({
        url: userApi.itemList,
        method: "post",
        headers: {
            "Content-Type": "application/json"
        },
        transformRequest: [
            (data) => JSON.stringify(data)
        ],
        data: parameter,
    })
}

export function storeOrderList(parameter) {
    return axios({
        url: userApi.storeOrderList,
        method: "post",
        headers: {
            "Content-Type": "application/json"
        },
        transformRequest: [
            (data) => JSON.stringify(data)
        ],
        data: parameter,
    })
}

export function storeOrderRepair(parameter) {
    return axios({
        url: userApi.storeOrderRepair,
        method: "post",
        headers: {
            "Content-Type": "application/json"
        },
        transformRequest: [
            (data) => JSON.stringify(data)
        ],
        data: parameter,
    })
}

export function gachaRecordList(parameter) {
    return axios({
        url: userApi.gachaRecordList,
        method: "post",
        headers: {
            "Content-Type": "application/json"
        },
        transformRequest: [
            (data) => JSON.stringify(data)
        ],
        data: parameter,
    })
}

export function gachaRecordStats(parameter) {
    return axios({
        url: userApi.gachaRecordStats,
        method: "post",
        headers: {
            "Content-Type": "application/json"
        },
        transformRequest: [
            (data) => JSON.stringify(data)
        ],
        data: parameter,
    })
}

export function gachaSimulate(parameter) {
    return axios({
        url: userApi.gachaSimulate,
        method: "post",
        headers: {
            "Content-Type": "application/json"
        },
        transformRequest: [
            (data) => JSON.stringify(data)
        ],
        data: parameter,
    })
}

export function itemFlowList(parameter) {
    return axios({
        url: userApi.itemFlowList,
        method: "post",
        headers: {
            "Content-Type": "application/json"
        },
        transformRequest: [
            (data) => JSON.stringify(data)
        ],
        data: parameter,
    })
}

export function maintainAdd(parameter) {
    return axios({
        url: userApi.maintainAdd,
        method: "post",
        headers: {
            "Content-Type": "application/json"
        },
        transformRequest: [
            (data) => JSON.stringify(data)
        ],
        data: parameter,
    })
}

export function maintainWriteAdd(parameter) {
    return axios({
        url: userApi.maintainWriteAdd,
        method: "post",
        headers: {
            "Content-Type": "application/json"
        },
        transformRequest: [
            (data) => JSON.stringify(data)
        ],
        data: parameter,
    })
}

export function maintainDelay(parameter) {
    return axios({
        url: userApi.maintainDelay,
        method: "post",
        headers: {
            "Content-Type": "application/json"
        },
        transformRequest: [
            (data) => JSON.stringify(data)
        ],
        data: parameter,
    })
}

export function maintainChangeDesc(parameter) {
    return axios({
        url: userApi.maintainChangeDesc,
        method: "post",
        headers: {
            "Content-Type": "application/json"
        },
        transformRequest: [
            (data) => JSON.stringify(data)
        ],
        data: parameter,
    })
}

export function maintainWriteRmv(parameter) {
    return axios({
        url: userApi.maintainWriteRmv,
        method: "post",
        headers: {
            "Content-Type": "application/json"
        },
        transformRequest: [
            (data) => JSON.stringify(data)
        ],
        data: parameter,
    })
}

export function maintainUndo(parameter) {
    return axios({
        url: userApi.maintainUndo,
        method: "post",
        headers: {
            "Content-Type": "application/json"
        },
        transformRequest: [
            (data) => JSON.stringify(data)
        ],
        data: parameter,
    })
}

export function maintainClose(parameter) {
    return axios({
        url: userApi.maintainClose,
        method: "post",
        headers: {
            "Content-Type": "application/json"
        },
        transformRequest: [
            (data) => JSON.stringify(data)
        ],
        data: parameter,
    })
}

export function maintainList(parameter) {
    return axios({
        url: userApi.maintainList,
        method: "post",
        headers: {
            "Content-Type": "application/json"
        },
        transformRequest: [
            (data) => JSON.stringify(data)
        ],
        data: parameter,
    })
}

export function maintainOut(parameter) {
    return axios({
        url: userApi.maintainOut,
        method: "post",
        headers: {
            "Content-Type": "application/json"
        },
        transformRequest: [
            (data) => JSON.stringify(data)
        ],
        data: parameter,
    })
}

export function accountLock(parameter) {
    return axios({
        url: userApi.accountLock,
        method: "post",
        headers: {
            "Content-Type": "application/json"
        },
        transformRequest: [
            (data) => JSON.stringify(data)
        ],
        data: parameter,
    })
}

export function accountUnlock(parameter) {
    return axios({
        url: userApi.accountUnlock,
        method: "post",
        headers: {
            "Content-Type": "application/json"
        },
        transformRequest: [
            (data) => JSON.stringify(data)
        ],
        data: parameter,
    })
}

export function accountLockInfo(parameter) {
    return axios({
        url: userApi.accountLockInfo,
        method: "post",
        headers: {
            "Content-Type": "application/json"
        },
        transformRequest: [
            (data) => JSON.stringify(data)
        ],
        data: parameter,
    })
}

export function redeemAdd(parameter) {
    return axios({
        url: userApi.redeemAdd,
        method: "post",
        headers: {
            "Content-Type": "application/json"
        },
        transformRequest: [
            (data) => JSON.stringify(data)
        ],
        data: parameter,
    })
}

export function redeemClose(parameter) {
    return axios({
        url: userApi.redeemClose,
        method: "post",
        headers: {
            "Content-Type": "application/json"
        },
        transformRequest: [
            (data) => JSON.stringify(data)
        ],
        data: parameter,
    })
}

export function redeemList(parameter) {
    return axios({
        url: userApi.redeemList,
        method: "post",
        headers: {
            "Content-Type": "application/json"
        },
        transformRequest: [
            (data) => JSON.stringify(data)
        ],
        data: parameter,
    })
}

export function redeemBatchAdd(parameter) {
    return axios({
        url: userApi.redeemBatchAdd,
        method: "post",
        headers: {
            "Content-Type": "application/json"
        },
        transformRequest: [
            (data) => JSON.stringify(data)
        ],
        data: parameter,
    })
}

export function redeemBatchList(parameter) {
    return axios({
        url: userApi.redeemBatchList,
        method: "post",
        headers: {
            "Content-Type": "application/json"
        },
        transformRequest: [
            (data) => JSON.stringify(data)
        ],
        data: parameter,
    })
}

export function redeemBatchPublish(parameter) {
    return axios({
        url: userApi.redeemBatchPublish,
        method: "post",
        headers: {
            "Content-Type": "application/json"
        },
        transformRequest: [
            (data) => JSON.stringify(data)
        ],
        data: parameter,
    })
}

export function redeemCodePage(parameter) {
    return axios({
        url: userApi.redeemCodePage,
        method: "post",
        headers: {
            "Content-Type": "application/json"
        },
        transformRequest: [
            (data) => JSON.stringify(data)
        ],
        data: parameter,
    })
}

export function redeemCodeExport(parameter) {
    return axios({
        url: userApi.redeemCodeExport,
        method: "post",
        headers: {
            "Content-Type": "application/json"
        },
        transformRequest: [
            (data) => JSON.stringify(data)
        ],
        data: parameter,
        responseType: "blob",
    })
}

export function redeemPlayerCodeList(parameter) {
    return axios({
        url: userApi.redeemPlayerCodeList,
        method: "post",
        headers: {
            "Content-Type": "application/json"
        },
        transformRequest: [
            (data) => JSON.stringify(data)
        ],
        data: parameter,
    })
}

export function notifyAdd(parameter) {
    return axios({
        url: userApi.notifyAdd,
        method: "post",
        headers: {
            "Content-Type": "application/json"
        },
        transformRequest: [
            (data) => JSON.stringify(data)
        ],
        data: parameter,
    })
}

export function notifyImportTemplate() {
    return axios({
        url: userApi.notifyImportTemplate,
        method: "get",
        responseType: "blob",
    })
}

export function notifyImport(parameter) {
    return axios({
        url: userApi.notifyImport,
        method: "post",
        headers: {
            "Content-Type": "multipart/form-data"
        },
        transformRequest: [
            (data) => data
        ],
        data: parameter,
    })
}

export function notifyList(parameter) {
    return axios({
        url: userApi.notifyList,
        method: "post",
        headers: {
            "Content-Type": "application/json"
        },
        transformRequest: [
            (data) => JSON.stringify(data)
        ],
        data: parameter,
    })
}

export function notifyChange(parameter) {
    return axios({
        url: userApi.notifyChange,
        method: "post",
        headers: {
            "Content-Type": "application/json"
        },
        transformRequest: [
            (data) => JSON.stringify(data)
        ],
        data: parameter,
    })
}

export function notifyRmv(parameter) {
    return axios({
        url: userApi.notifyRmv,
        method: "post",
        headers: {
            "Content-Type": "application/json"
        },
        transformRequest: [
            (data) => JSON.stringify(data)
        ],
        data: parameter,
    })
}

export function notifyPublishStatus(parameter) {
    return axios({
        url: userApi.notifyPublishStatus,
        method: "post",
        headers: {
            "Content-Type": "application/json"
        },
        transformRequest: [
            (data) => JSON.stringify(data)
        ],
        data: parameter,
    })
}

export function notifyPublish(parameter) {
    return axios({
        url: userApi.notifyPublish,
        method: "post",
        headers: {
            "Content-Type": "application/json"
        },
        transformRequest: [
            (data) => JSON.stringify(data)
        ],
        data: parameter,
    })
}

export function notifyUnpublish(parameter) {
    return axios({
        url: userApi.notifyUnpublish,
        method: "post",
        headers: {
            "Content-Type": "application/json"
        },
        transformRequest: [
            (data) => JSON.stringify(data)
        ],
        data: parameter,
    })
}
